module.exports = "<div class=\"loader\">\n  <svg class=\"circular\" viewBox=\"25 25 50 50\">\n    <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/>\n  </svg>\n  <p>Carregando...</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main